<li
    id="{{ id }}"
    class="dropdown__choice"
    role="option"
    [ngClass]="{'dropdown__key': isSelected}"
    [attr.aria-selected]="isSelected ? true : null"
    #listItem
    tabindex="-1"
>
    <ng-content></ng-content>
</li>
